module.exports = __webpack_public_path__ + "img/hw-s3.b4754923.svg";